/******************************************************************************
 *** BgtOvrlDpstImplInq ** 총괄 조합비 수입/지출 완료 조회 * 수입/지출 결의서 목록 조회
*******************************************************************************/
import React from "react";
import Util from "@/js/common/Util";
import SelectBox from "@/js/common/ui/input/SelectBox";
import StyledTabs from "@/js/common/ui/StyledTabs";
import { Tab, TabList, TabPanel } from "react-tabs";
import TextBox from "@/js/common/ui/input/TextBox";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";
import BgtOvrlImplDpstList from "./BgtOvrlImplDpstList.tsx";
import BgtOvrlImplExpndList from "./BgtOvrlImplExpndList";

const BgtOvrlDpstImplInq = () => {
    const userInfo = useRecoilValue(Atom.userInfo);

    // 검색 조건
    const [upOgnzCd  , setUpOgnzCd  ] = React.useState<string>(userInfo.upOgnzCd);      // 상위조직코드(본부)
    const [ognzCd    , setOgnzCd    ] = React.useState<string>(userInfo.ognzCd  );      // 조직코드(지부)
    const [acntgYear , setAcntgYear ] = React.useState<string>(Util.getNowAcntgYear()); // 회계연도
    const [searchKywd, setSearchKywd] = React.useState<string>(""); // 검색어(적요)

    // Tabs
    const [tabIndex, setTabIndex] = React.useState<number>(0); // 0: 수입, 1: 집행

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">교부금 결재완료 조회</span>
                <div className="bdt3 bdc007bff pb10" />
            </div>

            {/* 검색 영역 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">
                    {/* 소속 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36} fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setUpOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    {/* 지부 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={180} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    {/* 회계연도 */}
                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">회계연도</span>
                        <SelectBox value={acntgYear}
                            width={120} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={Util.getAcntgYearArray()}
                            placeholder="선택"
                            onChangeFunc={(data: string) => setAcntgYear(data)}
                        />
                    </div>

                    {/* 적요 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">적요</span>
                        <TextBox value={searchKywd}
                            width={200} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 12px" }}
                            placeholder="검색어 입력"
                            onChangeFunc={(text: string) => setSearchKywd(text)}
                        />
                    </div>
                </div>
            </div>

            {/* 탭 */}
            <StyledTabs selectedIndex={tabIndex} className="mb10 tabFit">
                <TabList>
                    <Tab onClick={() => setTabIndex(0)}>수입 결의서</Tab>
                    <Tab onClick={() => setTabIndex(1)}>지출 결의서</Tab>
                </TabList>

                {/* ========================= 수입 탭 ========================= */}
                <TabPanel>
                    <BgtOvrlImplDpstList
                        ognzCd     = {ognzCd}       // 조직
                        acntgYear  = {acntgYear}    // 회계연도
                        searchKywd = {searchKywd}   // 검색어(적요)
                    ></BgtOvrlImplDpstList>
                </TabPanel>

                {/* ========================= 지출 탭 ========================= */}
                <TabPanel>
                    <BgtOvrlImplExpndList
                        ognzCd     = {ognzCd}       // 조직
                        acntgYear  = {acntgYear}    // 회계연도
                        searchKywd = {searchKywd}   // 검색어(적요)
                    ></BgtOvrlImplExpndList>
                </TabPanel>

            </StyledTabs>
        </div>
    );
};

export default BgtOvrlDpstImplInq;
